import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Firebaseの設定値
const firebaseConfig = {
  apiKey: "AIzaSyDfy1u-ds86DB-NrqMK4f6QL8DDRTCki48",
  authDomain: "shapesync-visualizer-d5zuw.firebaseapp.com",
  projectId: "shapesync-visualizer-d5zuw",
  storageBucket: "shapesync-visualizer-d5zuw.firebasestorage.app",
  messagingSenderId: "344540273728",
  appId: "1:344540273728:web:4c377d384cc37ef63bd3a5",
  measurementId: "G-Y0RER2CBK8"
};

// Firebaseの初期化
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);

export { app, db, storage };
